// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"581":"6aba25c1","896":"00733698"}[chunkId] + ".chunk.css";
};